module.exports = __webpack_public_path__ + "img/tariff-briefcase.215f912e.svg";